const SITE_URL = "https://georgiadream.ge";

export interface PricesItemListEntry {
  listingId: number;
  title: string;
  url: string;
  priceRange?: { lowPrice: number; highPrice: number; offerCount: number } | null;
  fromNightly?: number | null;
}

export interface PricesItemListLdInput {
  canonicalUrl: string;
  name: string;
  items: PricesItemListEntry[];
}

interface OfferLd {
  "@type": "AggregateOffer" | "Offer";
  priceCurrency: "USD";
  availability: "https://schema.org/InStock";
  url: string;
  lowPrice?: number;
  highPrice?: number;
  offerCount?: number;
  price?: number;
}

interface ApartmentLd {
  "@type": "Apartment";
  name: string;
  url: string;
  offers?: OfferLd;
}

interface ListItemLd {
  "@type": "ListItem";
  position: number;
  item: ApartmentLd;
}

export interface PricesItemListLd {
  "@context": "https://schema.org";
  "@type": "ItemList";
  name: string;
  url: string;
  numberOfItems: number;
  itemListElement: ListItemLd[];
}

function buildOffer(entry: PricesItemListEntry): OfferLd | undefined {
  const r = entry.priceRange;
  if (r && r.lowPrice > 0 && r.highPrice > 0) {
    return {
      "@type": "AggregateOffer",
      priceCurrency: "USD",
      lowPrice: r.lowPrice,
      highPrice: r.highPrice,
      offerCount: r.offerCount,
      availability: "https://schema.org/InStock",
      url: entry.url,
    };
  }
  if (Number.isFinite(entry.fromNightly ?? NaN) && (entry.fromNightly ?? 0) > 0) {
    return {
      "@type": "Offer",
      priceCurrency: "USD",
      price: entry.fromNightly!,
      availability: "https://schema.org/InStock",
      url: entry.url,
    };
  }
  return undefined;
}

export function buildPricesItemListLd({
  canonicalUrl,
  name,
  items,
}: PricesItemListLdInput): PricesItemListLd {
  const listItems: ListItemLd[] = items
    .filter((it) => Number.isFinite(it.listingId) && it.title)
    .map((it, idx) => {
      const apartment: ApartmentLd = {
        "@type": "Apartment",
        name: it.title,
        url: it.url,
      };
      const offer = buildOffer(it);
      if (offer) apartment.offers = offer;
      return {
        "@type": "ListItem",
        position: idx + 1,
        item: apartment,
      };
    });
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name,
    url: canonicalUrl,
    numberOfItems: listItems.length,
    itemListElement: listItems,
  };
}

export const PRICES_SITE_URL = SITE_URL;
